import React, { useState, useEffect } from "react";
import { login } from "../services/authService";
import { getAllProjekte } from '../services/firebaseDienstplanService';
import { getCurrentUser } from "../services/firebaseAuthService";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [projekte, setProjekte] = useState([]);
  const [projektName, setProjektName] = useState("");

  // Projekte laden und zuletzt gewähltes Projekt setzen
  useEffect(() => {
    getAllProjekte().then(projs => {
      setProjekte(projs);
      const last = localStorage.getItem('lastProjektId');
      if (last && projs.find(p => p.id === last)) setProjektName(last);
      else if (projs.length > 0) setProjektName(projs[0].id);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(email, password);
      localStorage.setItem('lastProjektId', projektName);
      // Benutzerdaten aus Firestore laden und im Local Storage speichern
      const userData = await getCurrentUser();
      localStorage.setItem("currentUser", JSON.stringify(userData));
      localStorage.setItem("isLoggedIn", "true");
      // Weiterleitung oder Erfolgsmeldung
    } catch (err) {
      setError("Login fehlgeschlagen: " + err.message);
    }
  };

  return (
    <div className="login-bg" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="login-container">
        <img src="/logo.png" alt="Logo" style={{ width: 150, maxWidth: '100%', display: 'block', margin: '0 auto 18px auto' }} />
        <h2 style={{ color: '#1976d2', marginBottom: 4, fontWeight: 700, textAlign: 'center' }}>Power Brandschutz</h2>
        <div style={{ color: '#444', fontSize: 16, marginBottom: 18, textAlign: 'center' }}>Verwaltungssystem für Brandschutz-Dienstleistungen</div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <input
            type="email"
            placeholder="E-Mail Adresse"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: 4, fontSize: '1em', marginBottom: 0 }}
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: 4, fontSize: '1em' }}
          />
          <button type="submit" style={{ background: '#1976d2', color: 'white', border: 'none', borderRadius: 4, padding: '10px', fontSize: '1em', cursor: 'pointer', fontWeight: 600 }}>Anmelden</button>
          {error && <div className="error">{error}</div>}
        </form>
        <div style={{ marginTop: 18 }}>
          <a href="/reset" style={{ color: '#1976d2', fontSize: 15, textDecoration: 'underline', cursor: 'pointer' }}>Passwort zurücksetzen</a>
        </div>
      </div>
    </div>
  );
}

export default Login; 